import Vapor from 'laravel-vapor'
import Cookies from 'js-cookie'

type PropTypes = {
  baseUrl: string
}

export interface useVaporUploadResult {
  uploadImage: (file: File) => Promise<any>
}

const useVaporImageUpload = ({ baseUrl }: PropTypes): useVaporUploadResult => {

  const uploadImage = (file: File) => {
    const token = Cookies.get('XSRF-TOKEN')
    return Vapor.store(file, { baseURL: baseUrl, options: { withCredentials: 'include' }, headers: { 'X-XSRF-TOKEN': token } })
  }

  return {
    uploadImage,
  }
}

export default useVaporImageUpload
